<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        prepend-icon="mdi-calendar"
        :readonly="readonly"
        v-bind="attrs"
        :disabled="disabled"
        v-on="on"
        @change="change"
        v-mask="'##/##/####'"
      />
    </template>
    <v-date-picker
      v-model="date"
      locale="th"
      @input="
        menu = false
        dateChange()
      "
      :readonly="readonly"
    />
  </v-menu>
</template>

<script>
import Vue from "vue"

export default Vue.extend({
  props: {
    change: {
      type: Function,
      default: () => 1,
    },
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "วันที่",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: (vm) => ({
    dateFormatted: null,
    date: null,
    menu: false,
  }),
  computed: {},
  watch: {
    dateFormatted() {
      this.date = this.parseDate(this.dateFormatted)
      this.$emit("update:value", this.dateFormatted)
    },
    value() {
      this.init()
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.dateFormatted = this.value
    },
    dateChange() {
      this.dateFormatted = this.formatDate(this.date, 1)
      this.$emit("update:value", this.dateFormatted)
    },
    formatDate(date, type) {
      if (!date) return null
      if (type == 1) {
        const [year, month, day] = date.split("-")
        return `${day ? day.padStart(2, "0") : "00"}/${month ? month.padStart(2, "0") : "00"}/${String(
          Number(year) + 543
        ).padStart(4, "0")}`
      } else {
        const [day, month, year] = date.split("/")
        return `${String(Number(year)).padStart(4, "0")}${month ? month.padStart(2, "0") : "00"}${
          day ? day.padStart(2, "0") : "00"
        }`
      }
    },
    parseDate(date, splitter = "/") {
      if (!date) return null
      if (splitter != "" && date.toString().length != 10) return null
      if (splitter == "" && date.toString().length != 8) return null
      if (date.toString().length != 10) return null
      const [day, month, year] =
        splitter != ""
          ? date.toString().split("/")
          : [date.toString().substring(6), date.toString().substring(4, 6), date.toString().substring(0, 4)]

      return `${Number(year) - 543}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
    },
  },
})
</script>
